import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { SEU_ENVIRONMENT } from './environments/environment';

if (SEU_ENVIRONMENT.production) {
  enableProdMode();
}

if (SEU_ENVIRONMENT.sentryEnabled) {
  Sentry.init({
    dsn: 'https://cf2c70f400c593b5d09d7a5d9bdf90be@o4509241951846400.ingest.de.sentry.io/4509241955582032',

    environment: SEU_ENVIRONMENT.env,
    tracesSampleRate: SEU_ENVIRONMENT.env === 'prod' ? 0.2 : 1.0,
    // https://api.test.processdesigner.scheuch.com
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api\.test\.processdesigner\.scheuch\.com/,
      /^https:\/\/api\.processdesigner\.scheuch\.com/,
    ],
    integrations: [Sentry.browserTracingIntegration()],

    // eslint-disable-next-line @typescript-eslint/no-require-imports
    release: require('package.json').version,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
